<template>
    <div class="test-list">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>用户分组信息(删除需谨慎)</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search" style="align-items: center;">
            <div><el-button type="success" size="small" @click.native="clickAdd">添加用户到分组</el-button></div>
        </div>
        <div class="list" style="margin-top: 20px;">
            <el-table :data="allGroupingDetails" style="width: 100%" size="mini" stripe
                :row-class-name="tableRowClassName">
                <el-table-column prop="id" label="用户id"></el-table-column>
                <el-table-column prop="name" label="用户姓名"></el-table-column>
                <el-table-column prop="mobile" label="用户手机号"></el-table-column>
                <el-table-column fixed="right" label="操作" width="230">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="clickGrouping(scope.row.id)">查看信息</el-button>
                        <el-button type="danger" @click="clickDelet(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- <div class="block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
                :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div> -->
        <el-dialog title="添加数据" :visible.sync="dialogAddData" width="80%" top="6vh" center @close="closeDialogAdd">
            <div class="search_style">
                <div style="margin-right: 20px;">
                    <el-input placeholder="请输入手机号" prefix-icon="el-icon-search" size="small" clearable v-model="key"
                        @keyup.enter.native="Query"></el-input>
                </div>
                <div style="margin-right: 20px;">
                    <el-input placeholder="请输入用户名" prefix-icon="el-icon-search" size="small" clearable
                        v-model="user_name" @keyup.enter.native="Query"></el-input>
                </div>
                <div style="margin-right: 20px;">
                    <el-input placeholder="请输入用户id" prefix-icon="el-icon-search" size="small" clearable
                        v-model="user_id" @keyup.enter.native="Query"></el-input>
                </div>
                <div style="margin-right: 20px;"> <el-button type="primary" size="small"
                        @click.native="Query">查询</el-button>
                </div>
                <div> <el-button type="warning" size="small" @click.native="resetBtn">重置</el-button></div>
            </div>
            <el-table :data="userList" border style="width: 100%" :row-class-name="tableRowClassName" size="small">
                <el-table-column prop="id" label="用户id" fixed width="70"></el-table-column>
                <el-table-column prop="name" label="用户名" fixed width="75"></el-table-column>
                <el-table-column prop="mobile" label="手机号" width="95"></el-table-column>
                <el-table-column prop="ctime" label="注册时间" width="133"></el-table-column>
                <el-table-column prop="last_login_time" label="最后登录时间" width="133"></el-table-column>
                <el-table-column prop="reg_days" label="注册总天数" width="60"></el-table-column>
                <el-table-column prop="login_count" label="登录次数" width="50"></el-table-column>
                <el-table-column prop="login_days" label="登陆总天数" width="60"></el-table-column>
                <el-table-column prop="session_duration" label="登录总时长" width="125"></el-table-column>
                <el-table-column prop="age" label="年龄" width="50"></el-table-column>
                <el-table-column prop="gender" label="性别" width="50"></el-table-column>
                <el-table-column prop="height" label="身高(cm)" width="75"></el-table-column>
                <el-table-column prop="weight" label="体重(kg)" width="70"></el-table-column>
                <el-table-column prop="district" label="更多操作" fixed="right" width="100">
                    <template slot-scope="scope">
                        <el-button type="success" size="mini"
                            @click="copyContent(scope.row.id, scope.row)">选择</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-form :model="addData" :rules="rules" ref="addData">
                <el-form-item label="用户id" :label-width="formLabelWidth" prop="user_id">
                    <el-input v-model="addData.user_id" autocomplete="off" placeholder="请输入分组号"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogAdd">取 消</el-button>
                <el-button type="primary" @click="submitFormAdd">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="*提示" :visible.sync="dialogDelete" width="30%" center>
            <div style="text-align: center;font-size: 25px;">是否删除此数据？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogDelete = false">取 消</el-button>
                <el-button type="danger" @click="delUserGrouping">删 除</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            formLabelWidth: '150px',
            pages: 1,
            limit: 10,
            deBugList: [],
            total: 0,
            dateValue: '',
            allGroupingDetails: [],
            dialogAddData: false,
            rules: {
                user_id: [
                    { required: true, message: '用户id为必填项', trigger: 'change' }
                ],
            },
            delData: {},
            dialogDelete: false,
            allGroupInfo: [],
            addData: {
                user_id: '',
                group_id: ''
            },
            key: '',
            user_name: '',
            user_id: '',
            userList: []
        }
    },
    created() {
        this.getUserGroupingDetails()
    },
    methods: {
        getUserGroupingDetails() {
            this.$get(`/v1/admin/groups/list-group-members?group_id=${this.$route.query.group_id}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    console.log(res.data.data, '0000000000000000')
                    this.allGroupingDetails = res.data.data
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 1) {
                return '';
            } else {
                return 'success-row';
            }
        },
        clickDelet(index, row) {
            this.dialogDelete = true
            this.delData = row
            console.log(index, row.id)
        },
        delUserGrouping() {
            this.$delete(`/v1/admin/groups/users?user_id=${this.delData.id}&group_id=${this.$route.query.group_id}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    this.$message.success('删除成功')
                    this.getUserGroupingDetails()
                } else {
                    this.$msg(res.data.msg)
                }
            });
            this.dialogDelete = false
        },
        clickGrouping(id) {
            console.log(id, 'scope.row.idscope.row.idscope.row.id==============')
            this.$router.push({
                path: '/',
                query: {
                    user_id: id,
                }
            });
        },
        Query() {
            this.pages = 1;
            this.getUserList();
        },
        resetBtn() {
            this.key = this.user_name = this.user_id = ''
            this.pages = 1;
            this.getUserList();
        },
        clickAdd() {
            this.dialogAddData = true
            this.getUserList();
        },
        closeDialogAdd() {
            this.dialogAddData = false
            this.key = this.user_name = this.user_id = ''
        },
        submitFormAdd() {
            this.$refs.addData.validate((valid) => {
                if (valid) {
                    this.postUserToGroup()
                } else {
                    this.$message.error('请输入内容!')
                    return false;
                }
            });
        },
        postUserToGroup() {
            let apiData = {
                user_id: Number(this.addData.user_id),
                group_id: Number(this.$route.query.group_id)
            }
            console.log(apiData, 'apiDataapiData')
            this.$post(`/v1/admin/groups/users`, apiData).then((res) => {
                if (res.data.status === 'success') {
                    this.$message.success(res.data.msg)
                    this.closeDialogAdd()
                    this.getUserGroupingDetails()
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        copyContent(index, row) {
            console.log(index, row, '选择')
            this.addData.user_id = row.id
        },
        getUserList() {
            this.$get(`/v1/admin/users?pages=${this.pages}&limit=${this.limit}&key=${this.key}&user_name=${this.user_name}&user_id=${this.user_id}`, {})
                .then((res) => {
                    if (res.data.status === 'success') {
                        this.userList = res.data.data.data;
                    } else {
                        this.$msg(res.data.msg)
                    }
                });
        },
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.flex_box{
    margin: 12px;
    text-align right
}

.flex_box div {
    margin 10px
}

.right_box div {
    margin 10px
}
.right_box{
    color: red;
}

.dialog_style{
    display flex
    align-items center
    justify-content center
    font-size 19px
    color #000
}

   .el-select .el-input {
      width: 200px;
    }
  .test-list
      .el-table .warning-row {
        background: oldlace;
      }
  
      .el-table .success-row {
        background: #f0f9eb;
      }
  
      .search
        margin 20px 0
        display flex
        justify-content flex-start
        input
          width 220px
          margin-right 20px
        .add
          padding-left 100px
  
      .list
        min-height 550px
        border 1px solid #EBEEF5
        .edit_icon
          width 20px
          height 20px
          margin-left 16px
          border 1px solid  #ccc
          border-radius 4px
  
  </style>
<style scoped>
.custom-content {
    display: -webkit-box;
    /* 作为弹性盒子模型显示 */
    -webkit-box-orient: vertical;
    /* 设置弹性盒子主轴方向为垂直 */
    overflow: hidden;
    /* 隐藏超出内容 */
    text-overflow: ellipsis;
    /* 在内容超出时显示省略号（但此属性在此场景下可能不直接生效，由-webkit-line-clamp处理） */
    max-height: 100px;
    /* 设置最大高度，与行数限制共同决定最终显示效果 */
    line-height: normal;
}

.search_style {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/user_grouping/user_grouping_details.vue